var React = require('react');

function ContactTriangleMobile1 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 7.04395L12.1965 53.8043M1 7.04395L25.9537 26.9516M1 7.04395L53.3503 30.7421M12.1965 53.8043L25.9537 26.9516M12.1965 53.8043L53.3503 30.7421M25.9537 26.9516L53.3503 30.7421","stroke":"#FF9EB6"}));
}

ContactTriangleMobile1.defaultProps = {"width":"57","height":"56","viewBox":"0 0 57 56","fill":"none"};

module.exports = ContactTriangleMobile1;

ContactTriangleMobile1.default = ContactTriangleMobile1;
